import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import {
  addProfileProperty,
  setProfileProperties,
} from './profilePropertiesSlice';
import { type DecoratedProperty } from '@flemingmetrics/api-client';

type PropertiesState = {
  byId: Record<string, DecoratedProperty>;
};

const initialState: PropertiesState = {
  byId: {},
};

export const propertiesSlice = createSlice({
  name: 'properties',
  initialState,
  reducers: {
    addProperty: (state, action: PayloadAction<DecoratedProperty>) => {
      return getNextState(state, [action.payload]);
    },
    setProperties: (state, action: PayloadAction<DecoratedProperty[]>) => {
      return getNextState(state, action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addProfileProperty, (state, action) => {
        return getNextState(state, [action.payload.property]);
      })
      .addCase(setProfileProperties, (state, action) => {
        return getNextState(
          state,
          action.payload.map(({ property }) => property)
        );
      })
      .addDefaultCase(() => {});
  },
});

function getNextState(state: PropertiesState, properties: DecoratedProperty[]) {
  const byId = { ...state.byId };
  properties.forEach((p) => {
    byId[p.id] = p;
  });
  return { byId };
}

export const { addProperty, setProperties } = propertiesSlice.actions;

export default propertiesSlice.reducer;
